import { IFormValues } from "../Models/FeedbackForm";

export async function getFeedbackData(intl: any, lang: string, isProd: boolean, localizationUrl: string, inputFieldValues: IFormValues) {
    const en = "en";
    const enus = "en-us";
    const fr = "fr";
    const space = " ";
    const NoComments = "N/A";

    let preferredLang: string;

    if (inputFieldValues.preferredLanguage.length === 0 || inputFieldValues.contactMethod === "None") {
        preferredLang = lang;
    }
    else {
        switch (inputFieldValues.preferredLanguage) {
            case "English":
                preferredLang = en;
                break;
            case "French":
                preferredLang = fr;
                break;
            default:
                preferredLang = en;
                break;
        }
    }

    let subjectTypesToSend = intl.formatMessage({ id: "Accessibility_feedback" });
    let preferredLanguageToSend = intl.formatMessage({ id: inputFieldValues.preferredLanguage });
    let brailleFormatTypeToSend = inputFieldValues.brailleFormatType;
    let electronicFormatTypeToSend = inputFieldValues.electronicFormatType;
    let audioFormatTypeToSend = inputFieldValues.audioFormatType;
    let audioDeliveryTypeToSend = inputFieldValues.audioDeliveryType;
    let RAF_countryToSend = inputFieldValues.RAF_country ? intl.formatMessage({ id: inputFieldValues.RAF_country }) : inputFieldValues.RAF_country;
    let RAF_provinceToSend = inputFieldValues.RAF_province ? intl.formatMessage({ id: inputFieldValues.RAF_province }) : inputFieldValues.RAF_province;
    let feedbackSubjectToSend = intl.formatMessage({ id: inputFieldValues.feedbackSubject });
    let alternateFormatDocumentsToSend = inputFieldValues.alternateFormatDocuments;
    let requestAlternateFormatTypesToSend = inputFieldValues.requestAlternateFormatTypes ? intl.formatMessage({ id: inputFieldValues.requestAlternateFormatTypes }) : inputFieldValues.requestAlternateFormatTypes;
    let contactMethodToSend = intl.formatMessage({ id: inputFieldValues.contactMethod });

    if (preferredLang === lang) {
        alternateFormatDocumentsToSend = inputFieldValues.alternateFormatDocuments.map(x =>
            x.replace("Description_of_the_feedback_process", intl.formatMessage({ id: "Description_of_the_feedback_process"}))
            .replace("The_accessibility_plan", intl.formatMessage({ id: "The_accessibility_plan"}))
            .replace("The_accessibility_progress_report", intl.formatMessage({ id: "The_accessibility_progress_report"})));

        brailleFormatTypeToSend = inputFieldValues.brailleFormatType.map(x =>
            x.replace("Braille_1", intl.formatMessage({ id: "Braille_1"}))
            .replace("Braille_2", intl.formatMessage({ id: "Braille_2"})));

        electronicFormatTypeToSend = inputFieldValues.electronicFormatType.map(x =>
            x.replace("Microsoft_Word", intl.formatMessage({ id: "Microsoft_Word"}))
            .replace("PDF", intl.formatMessage({ id: "PDF"}))
            .replace("TXT", intl.formatMessage({ id: "TXT"})));

        audioFormatTypeToSend = inputFieldValues.audioFormatType.map(x =>
            x.replace("WAV", intl.formatMessage({ id: "WAV"}))
            .replace("MP3", intl.formatMessage({ id: "MP3"})));

        audioDeliveryTypeToSend = inputFieldValues.audioDeliveryType.map(x =>
            x.replace("CD_ROM", intl.formatMessage({ id: "CD_ROM"}))
            .replace("USB", intl.formatMessage({ id: "USB"})));
    }
    else {
        let messageData: any = await getValuesToSend(preferredLang, localizationUrl);

        if (messageData) {
            subjectTypesToSend = messageData[preferredLang]["Accessibility_feedback"];
            preferredLanguageToSend = messageData[preferredLang]["French"];

            alternateFormatDocumentsToSend = inputFieldValues.alternateFormatDocuments.map(x =>
                x.replace("Description_of_the_feedback_process", messageData[preferredLang]["Description_of_the_feedback_process"])
                .replace("The_accessibility_plan", messageData[preferredLang]["The_accessibility_plan"])
                .replace("The_accessibility_progress_report", messageData[preferredLang]["The_accessibility_progress_report"]));

            brailleFormatTypeToSend = inputFieldValues.brailleFormatType.map(x =>
                x.replace("Braille_1", messageData[preferredLang]["Braille_1"])
                .replace("Braille_2", messageData[preferredLang]["Braille_2"]));

            electronicFormatTypeToSend = inputFieldValues.electronicFormatType.map(x =>
                x.replace("Microsoft_Word", messageData[preferredLang]["Microsoft_Word"])
                .replace("PDF", messageData[preferredLang]["PDF"])
                .replace("TXT", messageData[preferredLang]["TXT"]));

            audioFormatTypeToSend = inputFieldValues.audioFormatType.map(x =>
                x.replace("WAV", messageData[preferredLang]["WAV"])
                .replace("MP3", messageData[preferredLang]["MP3"]));

            audioDeliveryTypeToSend = inputFieldValues.audioDeliveryType.map(x =>
                x.replace("CD_ROM", messageData[preferredLang]["CD_ROM"])
                .replace("USB", messageData[preferredLang]["USB"]));

            switch (inputFieldValues.feedbackSubject) {
                case "Request_alternate_format":
                    feedbackSubjectToSend = messageData[preferredLang]["Request_alternate_format"];
                    break;
                case "Employment":
                    feedbackSubjectToSend = messageData[preferredLang]["Employment"];
                    break;
                case "Buildings_stores":
                    feedbackSubjectToSend = messageData[preferredLang]["Buildings_stores"];
                    break;
                case "Digital_accessibility":
                    feedbackSubjectToSend = messageData[preferredLang]["Digital_accessibility"];
                    break;
                case "Customer_service":
                    feedbackSubjectToSend = messageData[preferredLang]["Customer_service"];
                    break;
                case "Products_and_services":
                    feedbackSubjectToSend = messageData[preferredLang]["Products_and_services"];
                    break;
                case "Other":
                    feedbackSubjectToSend = messageData[preferredLang]["Other"];
                    break;
                default:
                    break;
            }

            switch (inputFieldValues.requestAlternateFormatTypes) {
                case "Regular_print":
                    requestAlternateFormatTypesToSend = messageData[preferredLang]["Regular_print"];
                    break;
                case "Large_print":
                    requestAlternateFormatTypesToSend = messageData[preferredLang]["Large_print"];
                    break;
                case "Braille":
                    requestAlternateFormatTypesToSend = messageData[preferredLang]["Braille"];
                    break;
                case "Electronic":
                    requestAlternateFormatTypesToSend = messageData[preferredLang]["Electronic"];
                    break;
                case "Audio":
                    requestAlternateFormatTypesToSend = messageData[preferredLang]["Audio"];
                    break;
                case "Other":
                    requestAlternateFormatTypesToSend = messageData[preferredLang]["Other"];
                    break;
                default:
                    break;
            }

            switch (inputFieldValues.contactMethod) {
                case "Email":
                    contactMethodToSend = messageData[preferredLang]["Email"];
                    break;
                case "Telephone":
                    contactMethodToSend = messageData[preferredLang]["Telephone"];
                    break;
                case "Email_and_Telephone":
                    contactMethodToSend = messageData[preferredLang]["Email_and_Telephone"];
                    break;
                case "IP_relay":
                    contactMethodToSend = messageData[preferredLang]["IP_relay"];
                    break;
                case "TTY":
                    contactMethodToSend = messageData[preferredLang]["TTY"];
                    break;
                case "Video_relay_service":
                    contactMethodToSend = messageData[preferredLang]["Video_relay_service"];
                    break;
                case "None":
                    contactMethodToSend = messageData[preferredLang]["None"];
                    break;
                default:
                    break;
            }
        }
    }

    const appSuite = preferredLang === en ? "formField76" : "formField102";
    const province = preferredLang === en ? "formField83" : "formField103";
    const fullName = preferredLang === en ? "formField90" : "formField104";
    const describeOtherFormats = preferredLang === en ? "formField88" : "formField101";
    const telephoneNumber = preferredLang === en ? "formField89" : "formField105";
    const ipRelayNumber = preferredLang === en ? "formField91" : "formField106";
    const ttyNumber = preferredLang === en ? "formField92" : "formField92";
    const videoRelayServiceNumber = preferredLang === en ? "formField93" : "formField107";
    const selectFormat = preferredLang === en ? "formField75" : "formField95";
    const electronicType = preferredLang === en ? "formField84" : "formField96";
    const electronicDelivery = preferredLang === en ? "formField85" : "formField108";
    const audioType = preferredLang === en ? "formField80" : "formField97";
    const audioDelivery = preferredLang === en ? "formField81" : "formField98";
    const brailleType = preferredLang === en ? "formField82" : "formField99";
    const preferredLanguage = preferredLang === en ? "formField77" : "formField100";
    const contactMethod = preferredLang === en ? "formField72" : "formField94";
    const alternateFormatDocuments = preferredLang === en ? isProd ? "formField94" : "formField95" : "formField109";

    let responseObj = {
        "language": preferredLang.toLowerCase() === en ? enus : fr,
        "additionalData":
        {
            [describeOtherFormats]: inputFieldValues.otherFormatType.length === 0 ? space : inputFieldValues.otherFormatType,
            "requestDetails": inputFieldValues.comments.length === 0 ? NoComments : inputFieldValues.comments.replace(/"/g, "'").replace(/\\/g, " ").replace(/\//g, " "),
            "address": inputFieldValues.RAF_streetAdd.length === 0 ? space : inputFieldValues.RAF_streetAdd,
            [appSuite]: inputFieldValues.RAF_aptNo,
            "country": inputFieldValues.feedbackSubject === "Request_alternate_format" ? RAF_countryToSend : space,
            "city": inputFieldValues.RAF_city.length === 0 ? space : inputFieldValues.RAF_city,
            [province]: RAF_provinceToSend.length === 0 ? space : RAF_provinceToSend,
            "zip": inputFieldValues.RAF_postalCode.length === 0 ? space : inputFieldValues.RAF_postalCode,
            [fullName]: inputFieldValues.feedbackSubject === "Request_alternate_format" ? inputFieldValues.RAF_fullName.length === 0 ? space : inputFieldValues.RAF_fullName : inputFieldValues.fullName.length === 0 ? space : inputFieldValues.fullName,
            [telephoneNumber]: inputFieldValues.feedbackSubject === "Request_alternate_format" ? inputFieldValues.RAF_telephone.length === 0 ? space : inputFieldValues.RAF_telephone : inputFieldValues.telephone.length === 0 ? space : inputFieldValues.telephone,
            [ipRelayNumber]: inputFieldValues.ipRelay.length === 0 ? space : inputFieldValues.ipRelay,
            [ttyNumber]: inputFieldValues.ttyNumber.length === 0 ? space : inputFieldValues.ttyNumber,
            [videoRelayServiceNumber]: inputFieldValues.videoRelayService.length === 0 ? space : inputFieldValues.videoRelayService,
            "bce_brand": inputFieldValues.brand
        },
        "multiselectFields":
        {
            [alternateFormatDocuments]: alternateFormatDocumentsToSend.length === 0 ? [space] : alternateFormatDocumentsToSend,
            [selectFormat]: [requestAlternateFormatTypesToSend.length === 0 ? space : requestAlternateFormatTypesToSend],
            [electronicType]: electronicFormatTypeToSend.length === 0 ? [space] : electronicFormatTypeToSend,
            [electronicDelivery]: inputFieldValues.electronicDeliveryType.length === 0 ? [space] : inputFieldValues.electronicDeliveryType,
            [audioType]: audioFormatTypeToSend.length === 0 ? [space] : audioFormatTypeToSend,
            [audioDelivery]: audioDeliveryTypeToSend.length === 0 ? [space] : audioDeliveryTypeToSend,
            [brailleType]: brailleFormatTypeToSend.length === 0 ? [space] : brailleFormatTypeToSend,
            [contactMethod]: [contactMethodToSend.length === 0 ? space : contactMethodToSend],
            [preferredLanguage]: [(preferredLanguageToSend.length === 0 || inputFieldValues.contactMethod === "None") ? space : preferredLanguageToSend]
        },
        "requestTypes": [feedbackSubjectToSend],
        "email": inputFieldValues.feedbackSubject === "Request_alternate_format" ? inputFieldValues.RAF_email : inputFieldValues.emailAdd,
        "subjectTypes": [subjectTypesToSend]
    };

    return (responseObj);
}

async function getValuesToSend(preferredLanguage: string, localizationUrl: string) {
    try {
        const response = await fetch(localizationUrl, {
            method: "get",
            headers: {"Content-Type": "application/json; charset=UTF-8", "Accept-Language": preferredLanguage},
        });

        const data = await response.json();
        return data;
    }
    catch (error) {
        console.log("Error" + error);
    }
}